import { WifiOff, RefreshCcw } from "lucide-react";

const NoInternet = ({isSystemOnline}) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8 text-center">
        {/* Icon */}
        <div className="w-24 h-24 mx-auto rounded-full bg-red-100 flex items-center justify-center mb-6">
          <WifiOff size={48} className="text-red-500" />
        </div>

        <div
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full shadow-sm transition-all duration-500 ease-out ${
            isSystemOnline
              ? "bg-emerald-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full bg-white ${
              isSystemOnline ? "" : "animate-pulse"
            }`}
          />
          <span className="text-xs font-medium">
            {isSystemOnline ? "Online" : "Offline"}
          </span>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          No Internet Connection
        </h1>

        {/* Description */}
        <p className="text-gray-500 mb-6">
          Your device appears to be offline. Please check your network
          connection and try again.
        </p>

        {/* Tips */}
        <div className="bg-gray-50 rounded-2xl p-4 text-left mb-6">
          <h3 className="font-semibold text-gray-700 mb-2">
            Things to try:
          </h3>
          <ul className="text-sm text-gray-500 space-y-1">
            <li>• Check your Wi-Fi or mobile data.</li>
            <li>• Restart your router.</li>            
            <li>• Refresh the page.</li>
          </ul>
        </div>

        {/* Retry Button */}
        {/* <button
          // onClick={onRetry}
          className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-medium transition-all duration-300"
        >
          <RefreshCcw size={18} />
          Retry Connection
        </button> */}
      </div>
    </div>
  );
};

export default NoInternet;